<!-- users are guaranteed to have at least 1 badge upon sign-up -- the Orchestrators badge -->
<ng-container *ngIf="badges$ | async as badges; else selectTemplate">
    <ng-container *ngIf="badges.length > 0 || showFilter; else selectTemplate">
        <div class="badges-section">
            <div class="subpage-header-cta" [ngClass]="{ 'profile-header-cta': isAboutMePage$ | async }">
                <app-subpage-header
                    #badgesHeaderRef
                    [title]="title"
                    [subtitle]="'(' + badges.length + ')'"
                    size="small"></app-subpage-header>
                <ng-container *ngIf="!openNonModal; else link">
                    <a
                        matTooltip="View badge"
                        class="no-underline"
                        (click)="openBadgeDialog(badges)"
                        target="_blank"
                        [matTooltip]="showSectionCtaLabel"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000">
                        {{ showSectionCtaLabel }}
                        <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                    </a>
                </ng-container>
            </div>

            <p *ngIf="isAboutMePage$ | async" class="badges-update-notice"
                >*Points, badges, and tiers are updated nightly.</p
            >

            <div *ngIf="showFilter" class="badge-filter">
                <app-select
                    label="Filter by"
                    [options]="[
                        { text: BadgeSource.ALL, value: BadgeSource.ALL },
                        { text: BadgeSource.CERTIFICATIONS, value: BadgeSource.CERTIFICATIONS },
                        { text: BadgeSource.ORCHESTRATORS, value: BadgeSource.ORCHESTRATORS },
                    ]"
                    [control]="filterControl"
                    [width]="'300px'"
                    tooltip="Filter by source">
                </app-select>
            </div>

            <ng-container *ngIf="badges.length > 0; else emptyFilterState">
                <ul [class.center]="badges?.length < max">
                    <li *ngFor="let badge of badges | slice: 0 : length; let i = index; trackBy: trackByItem">
                        <a
                            matTooltip="View badge"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="2000"
                            (click)="openBadgeDetailDialog(badge, $event)">
                            <img
                                [src]="badge?.image"
                                [alt]="badge?.title"
                                width="114"
                                height="117"
                                class="badge-image" />
                            <ng-container *ngIf="showBadgeTitle">
                                <div class="badge-title">{{ badge?.title }}</div>
                            </ng-container>
                        </a>
                    </li>
                </ul>
                <app-load-more-button
                    *ngIf="badges.length > modifier"
                    [length]="length"
                    [max]="max"
                    [modifier]="modifier"
                    [disabled]="isLoadMoreDisabled"
                    [headerRef]="badgesHeaderRef"
                    (refreshLengthFn)="refreshLength($event)"></app-load-more-button>
            </ng-container>

            <ng-template #emptyFilterState>
                <ng-container *ngIf="filterControl.value !== BadgeSource.CERTIFICATIONS; else emptyCertifications">
                    <div class="profile-sign-up-now">
                        <span
                            >Explore the Achiever's Lounge to learn more about Orchestrator tiers and start earning
                            awards!</span
                        >
                        <a routerLink="/profile/achievers-lounge">
                            Visit the Achiever's Lounge<mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                        </a>
                    </div>
                </ng-container>
                <ng-template #emptyCertifications>
                    <div class="education-sign-up-now">
                        <span>Sign up for a Genesys Cloud certification course to earn an award!</span>
                        <a
                            routerLink="/education"
                            fragment="certifications"
                            [queryParams]="{ product: (selectedProduct$ | async)?.uid }">
                            Explore certifications<mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                        </a>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </ng-container>
</ng-container>

<!-- Template selector -->
<ng-template #selectTemplate>
    <ng-container *ngIf="isProfilePage$ | async; else educationSignUp">
        <ng-container *ngTemplateOutlet="profileSignUp"></ng-container>
    </ng-container>
</ng-template>

<!-- Profile page template -->
<ng-template #profileSignUp>
    <app-subpage-header [title]="title" [subtitle]="'(0)'" size="small"></app-subpage-header>
    <div class="profile-sign-up-now">
        <p>*Points, badges, and tiers are updated nightly.</p>
        <span>Explore the Achiever's Lounge to learn more about Orchestrator tiers and start earning awards!</span>
        <a routerLink="/profile/achievers-lounge">
            Visit the Achiever's Lounge<mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
        </a>
    </div>
</ng-template>

<!-- Education page template -->
<ng-template #educationSignUp>
    <app-subpage-header [title]="title" size="small"></app-subpage-header>
    <div class="education-sign-up-now">
        <span>Sign up for a {{ currentProduct?.displayName }} certification course to earn an award!</span>
        <a [href]="signUpUrl" target="_blank">
            Sign up now<mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
        </a>
    </div>
</ng-template>

<ng-template #link>
    <a
        matTooltip="View badge"
        class="no-underline"
        routerLink="/profile/achievers-lounge"
        [matTooltip]="showSectionCtaLabel"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000">
        {{ showSectionCtaLabel }}
        <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
    </a>
</ng-template>
